import { CrxBreadcrumb, CrxBreadcrumbItem, CrxButton, CrxDrawer, CrxHeading, CrxIcon, CrxInputSelect, CrxModal, CrxSearchContainer, CrxTable, CrxTableDataLabel, CrxTableDataRow, CrxTableHeadLabel, CrxTableHeadRow, CrxToast } from '@cortex/cortex-core'
import { Container, FilterContainer, HeaderContainer } from './styles'
import { useNavigate } from 'react-router-dom'
import { ROUTES_NAMES } from 'constants/name.routes'
import { highlightText } from 'utils/stringUtils'
import { useUnitySectors } from './hooks/useUnitySectors'
import { useSectorDrawer } from './hooks/useSectorDrawer'
import { SectorDrawerContent } from './components/SectorDrawerContent'
import { TbArrowsUpDown } from 'react-icons/tb'
import { useState } from 'react'

const tableHeader = [
  { 
    title: "Setor", 
    span: 10,
    sort: true,
    field: 'u_name'
  },
  { title: "Status", span: 1 },
  {
    title: "Ação", span: 1,
    icon: <CrxIcon
      icon="EditLine"
      size="md"
    />
  },
]

const UnitySectors = () => {
  const navigate = useNavigate()
  const [order, setOrder] = useState<string>('ORDERBY')

  const {
    searchSector,
    setSearchSector,
    searchStatus,
    setSearchStatus,
    sectorSelector,
    locationSelector,
    sectorDispatch,
    getStatus,
    sectorOrder,
    setSectorOrder
  } = useUnitySectors()

  const {
    openDrawer,
    setOpenDrawer,
    openModal,
    setOpenModal,
    openTransferModal,
    setOpenTransferModal,
    createNewSector,
    toastOpen,
    setToastOpen,
    toastMessage,
    getValues,
    watch,
    setValue,
    errors,
    handleSubmit,
    createSector,
    handleEdit,
    saveSector,
    updateSector,
    confirmTransferSector,
    handleStatusChange,
    isCheckingNotifications,
    hasNotifications,
    getAvailableSectors,
  } = useSectorDrawer({
    sectorDispatch,
    locationName: locationSelector?.location?.name,
    sectorsList: sectorSelector.sectorsList
  })

  /**
   * Responsável por definir a ordenação por campo selecionado na coluna da Table
   * Controla também o estado do orderBy
   * @param field
   */
  const handleClickOrderBy = (field: string) => {
    let selectedOrder = null
    if (order === 'ORDERBY') {
      selectedOrder = 'ORDERBYDESC'
    } else {
      selectedOrder = 'ORDERBY'
    }
    setOrder(selectedOrder)
    
    const orderFieldSelected = { field, order: selectedOrder }
    handlerTableOrderByField(orderFieldSelected)
  }

  /**
   * Usado para capturar o valor de ordenação escolhido na Table
   * @param orderFieldSelected - Valor retornado do componente Table ao clicar na ordenação
   */
  const handlerTableOrderByField = (orderFieldSelected: any) => {
    console.log('=== orderFieldSelected', orderFieldSelected)
    // Mapeamento de campos para ordenação
    const fieldMapping: { [key: string]: string } = {
      'u_name': 'u_name', // Campo do setor
    }
    
    // Aplica o mapeamento se existir, senão usa o campo original
    const mappedField = fieldMapping[orderFieldSelected.field] || orderFieldSelected.field
    
    const mappedOrder = {
      field: mappedField,
      order: orderFieldSelected.order
    }
    
    setSectorOrder(mappedOrder)
    console.log('Mapped Order:', mappedOrder)
  }


  return (
    <>
      <div className='fixed top-5 right-5 z-[99999] w-full'>
        <CrxToast
          buttonIconAriaLabel="Fechar o toast"
          heading="Sucesso"
          opened={toastOpen}
          onOpen={setToastOpen}
          type="positive"
        >
          {toastMessage}
        </CrxToast>
      </div>
      <div className='bg-white flex-1 pt-[37px]'>
        <HeaderContainer>
          <CrxHeading size="sm">
            {`${locationSelector?.location?.name} / Setores`}
          </CrxHeading>
          <CrxButton
            onClick={createSector}
            icon='PlusLine'
            showIcon
            style={{ 
              height: '64px',
              padding: '0 40px',
              gap: '4px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            Criar setor
          </CrxButton>
        </HeaderContainer>
        <div className="crx-row"
          style={{ paddingLeft: 40, paddingRight: 40 }}
        >
          <div className="crx-col-12">
            <CrxBreadcrumb>
              <CrxBreadcrumbItem onClick={() => navigate(`${ROUTES_NAMES.configurationsRoutes.configurationsUnities}`)}>
                Unidades
              </CrxBreadcrumbItem>
              <CrxBreadcrumbItem style={{ color: '#003DA5' }}>
                {`${locationSelector?.location?.name} / Setores`}
              </CrxBreadcrumbItem>
            </CrxBreadcrumb>
          </div>
        </div>
        <FilterContainer>
          <CrxSearchContainer
            id="input-text-setor"
            placeholder="Busque por palavra chave..."
            value={searchSector}
            onChange={(e) => setSearchSector((e.target as HTMLInputElement).value)}
          />
          <CrxInputSelect
            id="input-select-status"
            label="Status"
            placeholder="Selecione um status"
            defaultValue='Todos'
            onChange= {(e) => setSearchStatus(getStatus((e.target as HTMLInputElement).value))}
            value={searchStatus}
          >
            <option value="Todos">
              Todos
            </option>
            <option value="Ativo">
              Ativo
            </option>
            <option value="Inativo">
              Inativo
            </option>
          </CrxInputSelect>
        </FilterContainer>
        <Container>
          {sectorSelector.sectorsList.length === 0 ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              width: '100%',
              marginTop: 24,
            }}>
              <div style={{ fontWeight: 500, color: '#222', fontSize: 16 }}>
                Não encontramos resultados para sua busca.
              </div>
              <div style={{ color: '#666', fontSize: 14, marginTop: 8 }}>
                Tente revisar o termo digitado ou refazer a busca com outras palavras.
              </div>
            </div>
          ) : (
            <CrxTable>
              <CrxTableHeadRow>
                {tableHeader.map(i => (
                  <CrxTableHeadLabel style={{ width: `${i.span * 100 / 12}%` }}>
                    <div className="flex items-center gap-5">
                      {i.title}
                      {i.sort && (
                        <div 
                          onClick={() => handleClickOrderBy(i.field)}
                          style={{ cursor: 'pointer' }}
                        >
                          <TbArrowsUpDown className="w-4 h-4 text-black" />
                        </div>
                      )}
                    </div>
                  </CrxTableHeadLabel>
                ))}
              </CrxTableHeadRow>
              {sectorSelector.sectorsList.map(row => (
                <CrxTableDataRow style={{ cursor: 'pointer' }} onClick={() => handleEdit(row)}>
                  <CrxTableDataLabel>
                    {highlightText(row?.u_name ?? '', searchSector ?? '')}
                  </CrxTableDataLabel>
                  <CrxTableDataLabel>
                    <span className={`rounded font-Roboto px-2 py-1 ${row?.u_active == "true" ? "bg-[#E3F7BA] text-[#09512D]" : "bg-[#FECDC4] text-[#7F1500]"}`}>
                      {row?.u_active == "true" ? "Ativo" : "Inativo"}
                    </span>
                  </CrxTableDataLabel>
                  <CrxTableDataLabel>
                    <CrxIcon
                      icon="EditLine"
                      size="md"
                    />
                  </CrxTableDataLabel>
                </CrxTableDataRow>
              ))}
            </CrxTable>
          )}
        </Container>
      </div>
      <CrxDrawer
        className='z-[5]'
        buttonLabel="Salvar"
        heading={`${createNewSector ? "Criar" : "Editar"} setor`}
        isOpen={openDrawer}
        onDrawerAction={handleSubmit(saveSector)}
        onDrawerClose={() => setOpenDrawer(false)}
        showFixedBar
        showNavBar
        size="sm"
      >
        <SectorDrawerContent
          watch={watch}
          setValue={setValue}
          errors={errors}
          handleStatusChange={handleStatusChange}
          isCheckingNotifications={isCheckingNotifications}
          hasNotifications={hasNotifications}
          availableSectors={getAvailableSectors()}
          createNewSector={createNewSector}
        />
      </CrxDrawer>
      <CrxModal
        fixedBarProps={{
          buttonMiniProps: {
            children: 'Cancelar',
            onClick: () => setOpenModal(false),
            className: 'font-Roboto font-medium'
          },
          buttonProps: {
            children: 'Sim, confirmar!',
            onClick: updateSector,
            className: 'font-Roboto font-medium' 
          }
        }}
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        type="slot"
      >
        <div className='w-[80px] h-[80px] bg-[#FED9AC] rounded-full flex items-center justify-center' >
          <CrxIcon color='#7E3407' icon='WarningLine' size='md' />
        </div>

        <div className='max-w-[470px] gap-4 space-y-6 font-Roboto'>
          <h3 className='text-2xl text-typograpy-1'>
            Atenção!
          </h3>
          <p>
            Ao alterar o nome do setor, ele será atualizado em todas as notificações já cadastradas. Confirma essa mudança?
          </p>
        </div>

      </CrxModal>

      {/* Modal de Transferência de Setor */}
      <CrxModal
        fixedBarProps={{
          buttonMiniProps: {
            children: 'Cancelar',
            onClick: () => setOpenTransferModal(false),
            className: 'font-Roboto font-medium'
          },
          buttonProps: {
            children: 'Sim, confirmar!',
            onClick: confirmTransferSector,
            className: 'font-Roboto font-medium' 
          }
        }}
        isOpen={openTransferModal}
        onClose={() => setOpenTransferModal(false)}
        type="slot"
      >
        <div className='w-[80px] h-[80px] bg-[#FED9AC] rounded-full flex items-center justify-center' >
          <CrxIcon color='#7E3407' icon='WarningLine' size='md' />
        </div>

        <div className='max-w-[470px] gap-4 space-y-6 font-Roboto'>
          <h3 className='text-2xl text-typograpy-1'>
            Atenção!
          </h3>
          <p>
            Ao transferir as notificações para um novo setor, não será possível desfazer a ação. Confirma essa mudança?
          </p>
        </div>

      </CrxModal>


    </>
  )
}

export { UnitySectors }

